import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const receiveComplaint = createAction(ACTION.RECEIVE_COMPLAINT.REQUEST, id => ({id}));
export const clearState = createAction(ACTION.CLEAR_STATE, id => ({id}));
